<template lang="html">
  <v-content>
    <v-dialog max-width="500" v-model="timesheetConfirmationDialogOpened">
      <v-card flat class="content-container">
        <v-card-title class="title"> Confirmation </v-card-title>
        <v-card-text>
          <v-layout class="text-xs-left">
            Are you sure you want to submit the timesheet today? Previous days
            cannot be modified after submission.
          </v-layout>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer />
          <v-btn class="primary text-capitalize" @click="submitTimesheet">
            Yes
          </v-btn>
          <v-btn
            class="primary--text text-capitalize"
            outline
            @click="timesheetConfirmationDialogOpened = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="1000" v-model="dailyTimesheetDialogOpened">
      <v-card flat class="content-container">
        <v-card-title class="title">
          <v-flex class="text-xs-left"
            >Tasks for {{ selectedDay.name }} ({{
              moment(selectedDay.date).format('MMM D')
            }})</v-flex
          >
          <v-spacer />
          <v-btn
            @click="addWorkHour(selectedDay)"
            :disabled="currentTimesheet.status !== 'draft'"
            class="primary default-input text-capitalize"
          >
            <v-icon class="mr-2" size="20">add</v-icon>
            <div>Add Task</div>
          </v-btn>
        </v-card-title>
        <v-divider class="separator" />
        <v-card-text class="px-4">
          <v-layout column class="subheading">
            <v-flex class="text-xs-left">
              Total Hours: {{ totalDailyHour(selectedDay) }}
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="workHourHeaders"
            :items="selectedDay.workHours"
            class="text-xs-center body-2"
            item-key="id"
            hide-actions
          >
            <template slot="no-results">
              <v-alert :value="true" color="warning" icon="warning">
                Your search found no results.
              </v-alert>
            </template>
            <template slot="items" slot-scope="props">
              <tr>
                <td>
                  <v-autocomplete
                    class="default-input"
                    v-model="props.item.company_id"
                    item-text="text"
                    :items="companyClientViews"
                    item-value="id"
                    hide-details
                    solo
                    placeholder="Select a client"
                    :disabled="currentTimesheet.status !== 'draft'"
                  />
                </td>
                <td>
                  <v-text-field
                    type="number"
                    hide-details
                    :rules="hourRules"
                    solo
                    min="0"
                    precision="2"
                    class="default-input"
                    v-model.number="props.item.primary_hours"
                    :disabled="currentTimesheet.status !== 'draft'"
                  />
                </td>
                <!-- <td>
                    <v-text-field
                      type="number"
                      hide-details
                      :rules="hourRules"
                      solo
                      min="0"
                      class="default-input"
                      v-model.number="props.item.secondary_hours"
                      :disabled="currentTimesheet.status !== 'draft'"
                    />
                  </td> -->
                <!-- <td>
                    {{primaryAndSecondaryHours(props.item)}}
                  </td> -->
                <td>
                  <v-text-field
                    hide-details
                    solo
                    class="default-input"
                    v-model="props.item.comment"
                    placeholder="Required"
                    :disabled="currentTimesheet.status !== 'draft'"
                  />
                </td>
                <td>
                  <v-icon
                    @click="deleteWorkHour(props.item)"
                    :disabled="currentTimesheet.status !== 'draft'"
                    class="error--text"
                    style="cursor: pointer"
                    >delete</v-icon
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="primary text-capitalize"
            @click="saveDay"
            :disabled="!daySavable || currentTimesheet.status !== 'draft'"
          >
            Save
          </v-btn>
          <v-btn
            class="primary--text text-capitalize"
            outline
            @click="resetDailyTimesheetDialog"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container style="max-width: 1000px">
      <v-layout class="mb-4" align-center>
        <soraban-action-button
          @click="$router.go(-1)"
          icon="keyboard_arrow_left"
          help="Back"
        />
        <h1>Timesheet</h1>
        <v-spacer />
      </v-layout>
      <v-card flat class="content-container">
        <v-card-text class="px-4">
          <v-layout column class="mb-4">
            <v-layout align-center>
              <v-spacer />
              <v-btn @click="previousTimesheet" class="grey--text" flat fab>
                <v-icon style="cursor: pointer" large>
                  keyboard_arrow_left
                </v-icon>
              </v-btn>
              <v-flex>
                <div class="text-xs-center title primary--text">
                  {{ moment(currentTimesheet.start_date).format('ll') }} -
                  {{
                    moment(currentTimesheet.start_date)
                      .add(6, 'day')
                      .format('ll')
                  }}
                </div>
              </v-flex>
              <v-btn @click="nextTimesheet" class="grey--text" flat fab>
                <v-icon style="cursor: pointer" large>
                  keyboard_arrow_right
                </v-icon>
              </v-btn>
              <v-spacer />
            </v-layout>
            <v-layout class="pb-4">
              <!-- <v-flex xs6> -->
              <v-layout column>
                <v-flex class="text-xs-center subheading mt-4 grey--text">
                  Total hours worked this week:
                </v-flex>
                <v-flex
                  class="primary--text text-xs-center headline mb-4 font-weight-bold"
                >
                  {{ currentTimesheet.total_hours }}
                </v-flex>
              </v-layout>
              <!-- </v-flex> -->
              <!-- <v-flex xs6>
                <v-layout column>
                  <v-flex class="text-xs-center subheading mt-4 grey--text">
                    Status:
                  </v-flex>
                  <v-flex class="primary--text text-xs-center text-capitalize headline font-weight-bold mb-4">
                    {{currentTimesheet.status}}
                  </v-flex>
                </v-layout>
              </v-flex> -->
            </v-layout>
            <v-layout align-center class="mb-2">
              Click one the box below to start editing the number of hours for
              the day:
            </v-layout>
            <v-layout>
              <v-layout
                column
                :key="timesheetDay.id"
                v-for="timesheetDay in timesheetDays"
                @click="openDailyTimesheet(timesheetDay)"
                class="timesheet-day__container"
              >
                <v-flex class="grey--text">
                  {{ timesheetDay.name }}
                </v-flex>
                <v-flex class="mb-2">
                  {{ moment(timesheetDay.date).format('MMM D') }}
                </v-flex>
                <v-flex
                  class="subheading primary--text"
                  v-if="totalDailyHour(timesheetDay) > 0"
                >
                  <div v-if="totalDailyHour(timesheetDay) > 1">
                    {{ totalDailyHour(timesheetDay) }} hrs
                  </div>
                  <div v-else>{{ totalDailyHour(timesheetDay) }} hr</div>
                </v-flex>
                <v-flex class="subheading" v-else> - </v-flex>
              </v-layout>
            </v-layout>
          </v-layout>
        </v-card-text>
        <v-card-actions class="mb-4 mr-4">
          <v-spacer />
          <v-btn
            class="primary text-capitalize"
            @click="timesheetConfirmationDialogOpened = true"
            :disabled="currentTimesheet.status !== 'draft'"
          >
            {{
              currentTimesheet.status === 'draft'
                ? 'Submit for this week'
                : 'Submitted'
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import moment from 'moment';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import take from 'lodash/take';
import get from 'lodash/get';

export default {
  data() {
    return {
      timesheetConfirmationDialogOpened: false,
      dailyTimesheetDialogOpened: false,
      timesheetDays: [
        {
          id: 1,
          name: 'Monday',
          date: '',
          workHours: [],
        },
        {
          id: 2,
          name: 'Tuesday',
          date: '',
          workHours: [],
        },
        {
          id: 3,
          name: 'Wednesday',
          date: '',
          workHours: [],
        },
        {
          id: 4,
          name: 'Thursday',
          date: '',
          workHours: [],
        },
        {
          id: 5,
          name: 'Friday',
          date: '',
          workHours: [],
        },
        {
          id: 6,
          name: 'Saturday',
          date: '',
          workHours: [],
        },
        {
          id: 7,
          name: 'Sunday',
          date: '',
          workHours: [],
        },
      ],
      timesheetHeaders: [
        {
          text: '',
          align: 'right',
          sortable: false,
          width: '20%',
        },
        {
          text: 'Day',
          align: 'left',
          sortable: false,
          width: '60%',
        },
        {
          text: 'Hours',
          align: 'left',
          sortable: false,
          width: '25%',
        },
      ],
      workHourHeaders: [
        {
          text: 'Client',
          align: 'center',
          sortable: false,
          width: '40%',
        },
        {
          text: 'Hours',
          align: 'center',
          sortable: false,
          width: '15%',
        },
        // {
        //   text: 'Secondary Hours',
        //   align: 'center',
        //   sortable: false,
        //   width: '10%',
        // },
        // {
        //   text: 'Total Hours',
        //   align: 'center',
        //   sortable: false,
        //   width: '10%',
        // },
        {
          text: 'Comment',
          align: 'center',
          sortable: false,
          width: '40%',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          width: '5%',
        },
      ],
      currentTimesheet: {
        id: 0,
        start_date: moment(),
        work_hours: [],
      },
      selectedDay: {
        workHours: [],
      },
      hourRules: [v => v >= 0 || 'Enter in a valid amount.'],
    };
  },
  computed: {
    ...mapState('companies', ['companies']),
    ...mapGetters({
      currentUser: 'user',
      isAdvisor: 'isAdvisor',
    }),
    companyClientViews() {
      return [
        { id: -1, text: 'Admin Work' },
        ...this.companies.map(c => ({
          id: c.id,
          text: `${c.name} - ${c.user.full_name}`,
        })),
      ];
    },
    daySavable() {
      return this.selectedDay.workHours.every(workHour => {
        return (
          workHour.company_id &&
          this.primaryAndSecondaryHours(workHour) > 0 &&
          !isEmpty(workHour.comment)
        );
      });
    },
  },
  methods: {
    async resetDailyTimesheetDialog() {
      const response = await API.timesheet.getTimesheet(
        this.currentTimesheet.start_date,
      );
      this.currentTimesheet = response.data;
      this.currentTimesheet.work_hours.forEach(workHour => {
        if (!workHour.company_id) workHour.company_id = -1;
      });
      this.setWeekDays();
      this.dailyTimesheetDialogOpened = false;
    },
    async nextTimesheet() {
      const previousDate = moment(this.currentTimesheet.start_date);
      const nextWeek = previousDate.add(1, 'week');
      const today = moment();
      if (nextWeek <= today.add(1, 'day')) {
        const response = await API.timesheet.getTimesheet(
          nextWeek.toISOString(),
        );
        this.currentTimesheet = response.data;
        this.currentTimesheet.work_hours.forEach(workHour => {
          if (!workHour.company_id) workHour.company_id = -1;
        });
        this.setWeekDays();
      }
    },
    async previousTimesheet() {
      const previousDate = moment(this.currentTimesheet.start_date);
      const previousWeek = previousDate.subtract(1, 'week');
      const response = await API.timesheet.getTimesheet(
        previousWeek.toISOString(),
      );
      this.currentTimesheet = response.data;
      this.currentTimesheet.work_hours.forEach(workHour => {
        if (!workHour.company_id) workHour.company_id = -1;
      });
      this.setWeekDays();
    },
    async submitTimesheet() {
      const response = await API.timesheet.updateTimesheet({
        timesheetId: this.currentTimesheet.id,
        status: 'submitted',
      });
      this.currentTimesheet = response.data;
      this.timesheetConfirmationDialogOpened = false;
    },
    addWorkHour(day) {
      this.selectedDay.workHours.push({
        id: null,
        company_id: null,
        primary_hours: 0,
        secondary_hours: 0,
        comment: '',
      });
    },
    async deleteWorkHour(workHour) {
      if (workHour.id) {
        const response = await API.timesheet.deleteWorkHour(workHour.id);
      }
      const index = this.selectedDay.workHours.indexOf(workHour);
      if (index > -1) {
        this.selectedDay.workHours.splice(index, 1);
      }
    },
    async saveDay() {
      const start = async () => {
        await this.asyncForEach(this.selectedDay.workHours, async workHour => {
          if (workHour.id) {
            await this.updateWorkHour(workHour);
          } else {
            workHour = await this.createWorkHour(workHour);
          }
        });
        this.resetDailyTimesheetDialog();
      };
      start();
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    async updateWorkHour(workHour) {
      if (workHour.company_id === -1) workHour.company_id = null;
      const response1 = await API.timesheet.updateWorkHour({
        workHourId: workHour.id,
        companyId: workHour.company_id,
        primaryHours: workHour.primary_hours,
        secondaryHours: workHour.secondary_hours,
        comment: workHour.comment,
      });
    },
    async createWorkHour(workHour) {
      if (workHour.company_id === -1) workHour.company_id = null;
      const response2 = await API.timesheet.createWorkHour({
        timesheetId: this.currentTimesheet.id,
        companyId: workHour.company_id,
        date: this.selectedDay.date,
        primaryHours: workHour.primary_hours,
        secondaryHours: workHour.secondary_hours,
        comment: workHour.comment,
      });
      if (!workHour.company_id) workHour.company_id = -1;
      return workHour;
    },
    moment,
    openDailyTimesheet(day) {
      this.selectedDay = day;
      this.dailyTimesheetDialogOpened = true;
    },
    totalDailyHour(day) {
      let total = 0;
      day.workHours.forEach(
        workHour => (total += this.primaryAndSecondaryHours(workHour)),
      );
      return total;
    },
    primaryAndSecondaryHours(workHour) {
      return (
        (workHour.primary_hours !== '' ? workHour.primary_hours : 0) +
        (workHour.secondary_hours !== '' ? workHour.secondary_hours : 0)
      );
    },
    isEmpty,
    get,
    setWeekDays() {
      this.timesheetDays.forEach((day, i) => {
        if (i === 0) {
          day.date = moment(this.currentTimesheet.start_date).toISOString();
        } else {
          day.date = moment(this.currentTimesheet.start_date)
            .add(i, 'day')
            .toISOString();
        }
        day.workHours = this.currentTimesheet.work_hours.filter(
          w => moment(w.date).toISOString() === day.date,
        );
      });
    },
  },
  async created() {
    const today = moment();
    const beginningOfWeek = today.startOf('week').add(1, 'day');
    const response = await API.timesheet.getTimesheet(
      beginningOfWeek.toISOString(),
    );
    this.currentTimesheet = response.data;
    this.currentTimesheet.work_hours.forEach(workHour => {
      if (!workHour.company_id) workHour.company_id = -1;
    });
    this.setWeekDays();
  },
};
</script>

<style lang="postcss" scoped>
.timesheet-day__container {
  cursor: pointer;
  border: solid 0.2px rgba(9, 30, 66, 0.06) !important;
  padding-top: 15px;
  padding-bottom: 15px;
  width: 100px;
  margin-right: 7px;
}
</style>
